import { useEffect, useState } from 'react';
import { getConfig } from 'util/config';

/**
 * Subscribes to the per-domain runtime config. Returns `isLoading` until the
 * request settles; `config` is `{}` when the config could not be resolved.
 */
export const useConfig = () => {
  const [state, setState] = useState({ config: {}, isLoading: true });

  useEffect(() => {
    let isCurrent = true;

    getConfig().then(config => {
      if (isCurrent) setState({ config, isLoading: false });
    });

    return () => {
      isCurrent = false;
    };
  }, []);

  return state;
};
